/**
 * LogsModal Component
 *
 * Standalone modal for viewing application logs with filtering, search, and download.
 */

import React from "react";
import { Modal } from "../../../components/ui/Modal";
import { Button } from "../../../components/ui/Button";
import { AppLogsViewer } from "./AppLogsViewer";
import type { ApplicationSanitized } from "../../../types/application.types";

interface LogsModalProps {
  isOpen: boolean;
  onClose: () => void;
  tenantId: string;
  application: ApplicationSanitized;
}

/**
 * LogsModal component
 */
export const LogsModal: React.FC<LogsModalProps> = ({ isOpen, onClose, tenantId, application }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <Modal.Header>
        <div className="flex flex-col">
          <span>Logs - {application.applicationName}</span>
          <span className="text-sm font-normal text-gray-500 font-mono">{application.applicationCode}</span>
        </div>
      </Modal.Header>

      <Modal.Body>
        <AppLogsViewer tenantId={tenantId} applicationId={application.applicationId} />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
